import $ from "jquery";

var placeholderKey = "scrollfit.placeholder";

var setPos = window.isIOS ?
function(elt, css, viewPort) {
	// use absolute positioning for iOS as "fixed" is weird
	var ofp = elt[0].offsetParent;
	ofp = ofp != null ? $(ofp).offset() : { left: 0, top: 0 };
	css.position = "absolute";
	css.left += viewPort.left - ofp.left;
	css.top += viewPort.top - ofp.top;
	elt.css(css);
} :
function(elt, css) {
	elt.css(css);
};

function initPos(elt, clone, css, viewPort) {
	elt.css({ display: "none" });
	clone.css({ display: "" });
	$.extend(css, { width: clone.width(), height: clone.height() });
	var css1 = $.extend({}, css, { display: "" });
	setPos(elt, css1, viewPort);
}

function syncPos(elt, options, viewPort) {
	elt = $(elt);
	var eltRect;
	var isDoc = options.anchor === "window";
	var anc = options.anchor === "parent" ? elt.parent()
		: isDoc ? $(document)
			: $(options.anchor);
	var ancRect = $.extend({ left: 0, top: 0 }, isDoc ? {} : anc.offset(), { width: anc.width(), height: anc.height() });
	var clone = elt.data(placeholderKey);
	if(clone != null) {
		clone = $(clone);
		eltRect = $.extend(clone.offset(), { width: clone.outerWidth(), height: clone.outerHeight() });
	} else {
		eltRect = $.extend(elt.offset(), { width: elt.outerWidth(), height: elt.outerHeight() });
	}

	var css = {}, pref;

	// is there a place to scroll
	if(eltRect.left + eltRect.width <= ancRect.left + ancRect.width) {
		if(options.left != null) {
			if(eltRect.left < viewPort.left + options.left) {
				css.left = Math.min(options.left, ancRect.left + ancRect.width - (viewPort.left + eltRect.width));
			}
		}
		if(options.right != null) {
			pref = Math.min(
					Math.max(
						ancRect.left - viewPort.left,
						viewPort.width - options.right - eltRect.width),
					ancRect.left + ancRect.width - (viewPort.left + eltRect.width));
			if(options.left != null)
				pref = Math.min(css.left != null ? css.left : Math.max(options.left, eltRect.left - viewPort.left), pref);
			css.left = pref;
		}
	}
	if(eltRect.top + eltRect.height <= ancRect.top + ancRect.height) {
		if(options.top != null) {
			if(eltRect.top < viewPort.top + options.top) {
				css.top = Math.min(options.top, ancRect.top + ancRect.height - (viewPort.top + eltRect.height));
			}
		}
		if(options.bottom != null) {
			pref = Math.min(
					Math.max(
						ancRect.top - viewPort.top,
						viewPort.height - options.bottom - eltRect.height),
					ancRect.top + ancRect.height - (viewPort.top + eltRect.height));
			if(options.top != null) {
				if(css.top != null) {
					css.top = Math.min(css.top, pref);
				} else if(options.top > eltRect.top - viewPort.top) {
					css.top = options.top;
				}
			}
			else
				css.top = pref;
		}
	}
	// we have at least one position calculated, calculate another
	if(css.top != null && css.left == null) {
		css.left = eltRect.left - viewPort.left;
	} else if(css.left != null && css.top == null) {
		css.top = eltRect.top - viewPort.top;
	}

	if(!$.isEmptyObject(css)) {
		if(clone == null) {
			clone = options.placeholder(elt).addClass(options.placeholderClass).css({ "visibility": "hidden", "display": "none" }).insertAfter(elt);
			elt.data(placeholderKey, clone[0]).addClass("ui-sticky");
			$.extend(css, { position: "fixed" });
			initPos(elt, clone, css, viewPort);
		} else {
			setPos(elt, css, viewPort);
		}
	} else if(clone != null) {
		stop(elt);
	}
}

function syncSize(elt, options, viewPort) {
	elt = $(elt);
	var clone = elt.data(placeholderKey);
	if(clone != null) {
		clone = $(clone);
		elt.css({ width: clone.width(), height: clone.height() });
		syncPos(elt, options, viewPort);
	}
}

function delayRemoveClone(clone) {
	return function() { clone.parentNode.removeChild(clone); };
}

function stop(elt) {
	elt = $(elt);
	var clone = elt.data(placeholderKey);
	if(clone != null) {
		clone.style.display = "none";
		elt.removeData(placeholderKey).removeClass("ui-sticky").css({ position: "", left: "", top: "", width: "", height: "" });
		setTimeout(delayRemoveClone(clone), 1);
	}
}

function doScroll(options) {
	/* jshint validthis: true */
	var w = $(window);
	var viewPort = {
		left: w.scrollLeft(),
		top: w.scrollTop(),
		width: w.width(),
		height: w.height()
	};
	this.each(function() { syncPos(this, options, viewPort); });
}

function doResize(options) {
	/* jshint validthis: true */
	var w = $(window);
	var viewPort = {
		left: w.scrollLeft(),
		top: w.scrollTop(),
		width: w.width(),
		height: w.height()
	};
	this.each(function() { syncSize(this, options, viewPort); });
}

var placeholderStrategy = {
	fixSize: function(elt) {
		return $(elt[0].cloneNode(false)).css({ width: elt.width(), height: elt.height() });
	},
	fixHeight: function(elt) {
		return $(elt[0].cloneNode(false)).css({ height: elt.height() });
	},
	clone: function(elt) {
		return elt.clone(false);
	}
};

$.fn.sticky = function(options) {
	if(options !== "stop") {
		options = $.extend({
			fitFar: false,
			placeholderClass: "ui-sticky-placeholder",
			anchor: "parent",
			placeholder: "clone"
		}, options);

		options.placeholder = placeholderStrategy[options.placeholder] || options.placeholder;
		if(typeof options.placeholder !== "function")
			throw "placeholder is not a function or predefined constant";
	}

	var fnScroll = doScroll.bind(this, options);
	var fnResize = doResize.bind(this, options);

	if(options === "stop") {
		$(window).off("scroll", fnScroll).off("resize", fnResize);
		return this.each(stop);
	}
	$(window).on("scroll", fnScroll).on("resize", fnResize);
	return this;
};

$.scrollIntoView = function(elt, options) {

	elt = $(elt).eq(0);
	if(!elt.length)
		return;

	if(options === undefined)
		options = true;
	if(options === true || options === false)
		options = { block: options ? "start" : "end" };

	options = $.extend({}, { behavior: "auto", block: "start", select: ".ui-sticky" }, options);

	var w = $(window);

	// do it two times. position, update stickies, position

	function doScroll() {

		var viewPort = {
			// left: w.scrollLeft(),
			top: w.scrollTop(),
			// width: w.width(),
			height: w.height()
		};

		$(options.select).each(function() {
			var me = $(this);

			var mePort = me.offset();
			// mePort.width = me.outerWidth();
			mePort.height = me.outerHeight();

			// vertically on screen
			if(mePort.top + mePort.height > viewPort.top && mePort.top < viewPort.top + viewPort.height) {
				if(mePort.top <= viewPort.top) // top align
					viewPort.top += mePort.height;
				viewPort.height -= mePort.height;
			}
		});

		var eltPort = elt.offset();
		// eltPort.width = elt.outerWidth();
		eltPort.height = elt.outerHeight();

		if(eltPort.top < viewPort.top || eltPort.top + eltPort.height > viewPort.top + viewPort.height) {
			var dy = viewPort.top - eltPort.top;
			if(options.block === "end") {
				dy += viewPort.height - eltPort.height;
			}
			if(dy !== 0) {
				window.scrollBy(0, -dy);
				$(window).trigger("scroll");
			}
		}
	}

	doScroll();
	setTimeout(function() { doScroll(); }, 100);
};
